export const toUnderscore = str =>
  str.replace(/\.?([A-Z])/g, (x, y) => `_${y.toLowerCase()}`).replace(/^_/, '');

export function replaceVariablesWithContent(originalString, changeThis, forThis) {
  if (!originalString.length) return originalString;

  const changeThisEquals =
    changeThis.length > forThis.length ? changeThis.slice(0, forThis.length) : changeThis;
  const forThisEquals =
    forThis.length > changeThis.length ? forThis.slice(0, changeThis.length) : forThis;

  const result = changeThisEquals.reduce((prev, curr, index) => {
    const content = prev.replace(curr, forThisEquals[index]);
    return content;
  }, originalString);

  const outerVariableRegex = /#{[a-zA-Z]*}/;
  const outerVariables = result.match(outerVariableRegex);
  if (outerVariables) {
    return 'Valor inválido';
  }

  return result;
}
